define('../app/fukit/view/app.header.container.view',['require','exports','module','uikit/uikit','templates','./app.header.view','./header.nav.view'],function(require, exports, module) {
  //prettier-ignore
  var UIkit             = require('uikit/uikit'),
      Templates         = require('templates'),
      AppHeaderView     = require('./app.header.view'),
      HeaderNavView = require('./header.nav.view');

  var HeaderContainerView = UIkit.ItemView.extend({
    template: Templates.App['header.container'],
    internalViewOptions: {
      appHeaderView: {
        type: AppHeaderView,
      },
      headerNavView: {
        type: HeaderNavView,
      },
    },
  });

  module.exports = HeaderContainerView;
});

